import store from "@/store";

function formatResponseErrors(errors) {
  const formattedErrors = {};

  Object.keys(errors || {}).forEach((key) => {
    formattedErrors[key] = Array.isArray(errors[key])
      ? errors[key][0]
      : errors[key];
  });

  return formattedErrors;
}

const dispatchAction = async (
  values,
  actions,
  actionName,
  vueStore = store
) => {
  try {
    return await vueStore.dispatch(actionName, values, {
      root: true,
    });
  } catch (error) {
    const formattedErrors = formatResponseErrors(error.response?.data?.errors);
    actions.setErrors(formattedErrors);

    console.error(error);
    const err = new Error(error);
    err.formattedErrors = formattedErrors;
    err.responseErrors = error.response?.data?.errors;
    err.message = error.response?.data?.message || "";
    err.request = error.request;
    // Already surfaced to the user via actions.setErrors — the rethrow is for
    // submit-handler control flow only, not a bug for Sentry to capture.
    err.isExpectedFormError = true;
    throw err;
  }
};

const handleFormError = (error, actions) => {
  const formattedErrors = formatResponseErrors(error.response.data.errors);
  actions.setErrors(formattedErrors);

  console.error(error);
  const err = new Error(error);
  err.formattedErrors = formattedErrors;
  err.responseErrors = error.response?.data?.errors;
  err.isExpectedFormError = true;
  throw err;
};

const callStoreAction = async (values, actions, actionName, store) => {
  try {
    return await store[actionName](values);
  } catch (error) {
    handleFormError(error, actions);
  }
};

const submitWithErrorHandling = async (actions, callback) => {
  try {
    return await callback();
  } catch (error) {
    handleFormError(error, actions);
  }
};

// Returns a fallback "general" error message for an error thrown by
// dispatchAction / handleFormError. Returns empty string when the backend
// response carries per-field errors — those are already applied via setErrors.
const resolveGeneralFormError = (error, fallback) => {
  const formattedErrors = error?.formattedErrors;
  if (formattedErrors && Object.keys(formattedErrors).length > 0) {
    return "";
  }
  return error?.message || fallback;
};

export {
  callStoreAction,
  dispatchAction,
  formatResponseErrors,
  resolveGeneralFormError,
  submitWithErrorHandling,
};
